<template>
    <div class="page__wrapper" v-if="page.fields">
        <!-- <div class="page__main__image" v-if="page.fields.main_image && page.fields.main_image.value" :style="{'backgroundImage': 'url('+ fullScreenUrl(page.fields.main_image.value[0])+ ')'}"></div> -->
        <parallax :breakpoint="'(min-width: 992px)'" data-aos="fade-down" data-aos-delay="300">
            <img v-if="page.fields.main_image && page.fields.main_image.value" :src="fullScreenUrl(page.fields.main_image.value[0])" alt="">
        </parallax>
        <div class="page__content">
            <div class="page__grid-2">
                <div class="page__tags">
                    <span v-for="tag in page.tags" :key="tag.id"> {{tag.name}} </span>
                </div>
                <h2>{{page.title}}</h2>
            </div>
            <div class="page__grid-2" v-html="page.content"></div>
        </div>
        <div class="page__images">
            <template v-for="(image, index) in page.fields.images.value">
                <div class="image" :key="image.id" data-aos="fade-down" :data-aos-delay="(index*70)+ '0'">
                    <img :src="'/uploads/'+ image" alt="Project Image">
                </div>
            </template>
        </div>
        <div v-if="page.fields.last_image && page.fields.last_image.value" class="page__last__image" :style="{'backgroundImage': 'url('+ fullScreenUrl(page.fields.last_image.value[0])+ ')'}"></div>
        <div class="page__navigation">

            <div class="page__grid-2 prev" :class="{'not-active': !prev}">
                <router-link  v-if="prev" :to="{ name: 'page', params:{pageSlug: prev.slug}}">
                    <span>{{appConstants.translations[locale].prevBtn}}</span>
                    <h2>{{prev.title}}</h2>
                </router-link>
            </div>

            <div class="page__grid-2 next" :class="{'not-active': !next}">
                <router-link  v-if="next" :to="{ name: 'page', params:{pageSlug: next.slug}}">
                    <span>{{appConstants.translations[locale].nextBtn}}</span>
                    <h2>{{next.title}}</h2>
                </router-link>
            </div>

        </div>  
        <div class="lines lines--one__line" data-aos="fade"></div>     
    </div>
</template>

<script>
    import Parallax from 'vue-parallaxy'
    import _find from 'lodash/find'
    import {mapGetters} from 'vuex'

    export default {
        name: 'PageComponent',
        components: {
            Parallax
        },
        watch: {
            $route: function () {
                this.fetchData()
            }
        },
        created() {
            this.fetchData()
        }, 
        data () {
            return {
                page: {},
                next: undefined,
                prev: undefined,
                pageIndex: '',
                locale: this.$route.params.locale,                
                params: {
                    title: '',
                    description: '',
                    descriptionTwitter: '',
                    titleTwitter: '',                
                    descriptionFacebook: '',
                    titleFacebook: '',
                    image: '',
                    imageTwitter: '',
                    imageFacebook: '',
                    linkCanonical: ''
                }
            }
        },
        head: {
            title: function () {
                return {
                    inner: this.params.title,
                    separator: ' '
                }
            },
            meta: function () {
                return [
                    { n: 'description', c: this.params.description},
                    { n: 'keywords', c: this.params.keywords},
                    { n: 'twitter:title', c: this.params.titleTwitter},
                    { n: 'twitter:description', c: this.params.descriptionTwitter},
                    { n: 'twitter:image', c: `${url}/uploads/${this.params.imageTwitter}`},
                    { p: 'og:title', c: this.params.titleFacebook },
                    { p: 'og:description', c: this.params.descriptionFacebook},
                    { p: 'og:image', c: `${url}/uploads/${this.params.imageFacebook}`},
                    { p: 'og:url', h: `${url}`}
                ]
            },
            link: function() {
                return [
                    { r: 'canonical', h: this.params.linkCanonical}
                ]
            }
        },
        methods: {
            fetchData: function () {
                const pages = this.getProjects
                const page = _find(pages, {slug: this.$route.params.pageSlug})
                if(pages) {
                    const index = pages.indexOf(page);
                    this.next = pages[index+1]
                    this.prev = pages[index-1]
                    this.pageIndex = index
                }
                this.page = page
                this.params = this.formatMeta(this.page)
                this.$nextTick( () => {
                    this.$emit('updateHead')
                })
            }
        },
        computed: {
            ...mapGetters([
                'getProjects'
            ])
        }        
    }
</script>
